import { render, staticRenderFns } from "./wtAspectRatioTag.component.vue?vue&type=template&id=9d0e5676&scoped=true&"
import script from "./wtAspectRatioTag.component.vue?vue&type=script&lang=js&"
export * from "./wtAspectRatioTag.component.vue?vue&type=script&lang=js&"
import style0 from "./wtAspectRatioTag.component.vue?vue&type=style&index=0&id=9d0e5676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0e5676",
  null
  
)

export default component.exports